/* ============================================================
   IVHU custom scripts.

   Open / closed status (Pacific Time).
   Toggles `html.status-open` whenever the store is open so the
   CSS can color the contact-link status dots green vs gray.

   Hours:
     Mon-Fri  09:00 - 19:00  (9am - 7pm)
     Saturday 09:00 - 18:00  (9am - 6pm)
     Sunday   closed
   ============================================================ */
(function () {
  var OPEN_HOURS = {
    Mon: [540, 1140], Tue: [540, 1140], Wed: [540, 1140],
    Thu: [540, 1140], Fri: [540, 1140],
    Sat: [540, 1080]
  };

  function isOpenInPacificTime() {
    var parts = new Intl.DateTimeFormat("en-US", {
      timeZone: "America/Los_Angeles",
      weekday: "short",
      hour: "numeric",
      minute: "numeric",
      hour12: false
    }).formatToParts(new Date());

    var weekday = parts.find(function (p) { return p.type === "weekday"; }).value;
    var hour = parseInt(parts.find(function (p) { return p.type === "hour"; }).value, 10);
    var minute = parseInt(parts.find(function (p) { return p.type === "minute"; }).value, 10);

    // Intl reports hour as "24" at midnight; normalize to 0.
    if (hour === 24) hour = 0;

    var minutes = hour * 60 + minute;
    var window = OPEN_HOURS[weekday];
    return !!window && minutes >= window[0] && minutes < window[1];
  }

  function applyStatus() {
    document.documentElement.classList.toggle("status-open", isOpenInPacificTime());
  }

  applyStatus();
  // Re-check every minute so the dot flips at the opening/closing edge.
  setInterval(applyStatus, 60 * 1000);
})();
